<section
	class="obg-glide-wrapper"
	*ngIf="items"
	[class.obg-glide-loading]="!glide && isBrowser"
	[id]="uniqueClass"
	(resize)="onWrapperResize($event)"
	obgResizeObserver
	#wrapper
>
	<div data-glide-el="track">
		<div class="glide__slides">
			<ng-content></ng-content>
		</div>
	</div>

	<div *ngIf="!wingsHidden" class="obg-glide-wings">
		<div
			class="obg-glide-wings-prev"
			[class.obg-glide-wings-disabled]="items.length <= 1"
			*ngIf="leftWingWidth"
			role="button"
			(click)="navigateLeft()"
			[style.width]="leftWingWidth"
		></div>
		<div
			class="obg-glide-wings-next"
			[class.obg-glide-wings-disabled]="items.length <= 1"
			*ngIf="rightWingWidth"
			role="button"
			(click)="navigateRight()"
			[style.width]="rightWingWidth"
		></div>
	</div>

	<div class="obg-glide-arrows" *ngIf="!arrowsHidden">
		<span
			class="obg-glide-arrows-prev icon ico-chevron-right rotate-ico-180"
			role="button"
			(click)="navigateLeft()"
			[hidden]="prevArrowHidden"
		></span>
		<span
			class="obg-glide-arrows-next icon ico-chevron-right"
			role="button"
			(click)="navigateRight()"
			[hidden]="nextArrowHidden"
		></span>
	</div>

	<div class="obg-glide-pagination" *ngIf="!paginationHidden">
		<ng-template ngFor [ngForOf]="items" let-index="index" [ngForTrackBy]="trackByItems">
			<span
				class="obg-glide-pagination-item"
				[class.obg-glide-pagination-item-selected]="index === currentPage"
				(click)="navigateByPage(index)"
			></span>
		</ng-template>
	</div>
</section>
